export default __webpack_public_path__ + "static/media/529.c9993058.jpg";